import { FC } from 'react'
import { Divider } from '@/ui/components/Divider/Divider.styles'
import { HeaderSeverityBadge } from '@/ui/drawer/common/HeaderSeverityBadge'
import { HeaderStatusBadge } from '@/ui/components/HeaderStatusBadge'
import { BadgesWrapper } from '@/ui/drawer/common/drawerHeaderShared.styles'
import {
    getCaseSeverityVariant,
    getCaseStatus,
} from '@/ui/drawer/common/caseDrawerHeaderConfig/caseDrawerHeaderConfig.utils'
import { CaseDrawerHeaderBadgesProps } from './CaseDrawerHeaderBadges.types'

const CaseDrawerHeaderBadges: FC<CaseDrawerHeaderBadgesProps> = ({
    severity,
    status,
    variant = 'incident',
}) => {
    const severityVariant =
        variant === 'serviceRequest'
            ? undefined
            : getCaseSeverityVariant(severity)
    const caseStatus = getCaseStatus(status)

    if (!severityVariant && !caseStatus) return null

    const renderDivider = () => (
        <Divider vertical height="15px" data-testid="header-badge-divider" />
    )

    return (
        <BadgesWrapper data-testid="case-drawer-header-badges">
            {renderDivider()}
            {severityVariant && (
                <HeaderSeverityBadge severity={severityVariant} />
            )}
            {severityVariant && caseStatus && renderDivider()}
            {caseStatus && (
                <HeaderStatusBadge status={caseStatus} variant={variant} />
            )}
        </BadgesWrapper>
    )
}

export default CaseDrawerHeaderBadges
